import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider.tsx';
import React from 'react';
import LoadingCircle from './LoadingCircle.tsx';

function RequireAuth({ children }) {
  const { user, isAuthenticating } = useAuth();
  const [show, setShow] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
    }, 1100);

    return () => clearTimeout(timeout);
  }, [show]);

  if (isAuthenticating && !user) {
    return <LoadingCircle fullScreen />;
  }

  if (!user && !isAuthenticating) {
    if (!show) return <LoadingCircle fullScreen />;
    
    // Preserve the query parameters for when the user returns after login
    const currentPath = location.pathname + location.search;
    if (currentPath !== '/login' && location.search) {
      sessionStorage.setItem('redirectAfterLogin', currentPath);
    }
    
    return <Navigate to="/login" />;
  }

  return children;
}

export default RequireAuth;
